import { ColDef } from "ag-grid-community";
import { useMemo } from "react";
import { buildColumn } from "./ColumnFactory";

export function useProcessedColumnDefs(rawDefs: ColDef[], storageKey?: string): ColDef[] {
  return useMemo(() => {
    const savedWidths: { colId: string; width?: number }[] = storageKey
      ? JSON.parse(localStorage.getItem(storageKey) || "[]")
      : [];
    return rawDefs.map((col) => buildColumn(col, { savedWidths }));
  }, [rawDefs, storageKey]);
}
